import { ClipboardList, History, Truck, type LucideIcon } from 'lucide-react'
import { dashboardNavGroups } from '@/lib/dashboardNav'
import { dashboardNavIcons } from '@/lib/dashboardNavIcons'
import { dashboardModule } from '@/lib/dashboardWidgets'

/**
 * Each dashboard module's icon and colour, taken from its Home tile so a
 * widget reads as the same thing as the app it opens. Pick lists, Shipping and
 * Audit have no Home tile, so they carry their own here.
 */
const TILES = new Map(dashboardNavGroups.flatMap(g => g.items).map(t => [t.id, t]))

const OWN: Record<string, { icon: LucideIcon; tile: string }> = {
  'pick-lists': { icon: ClipboardList, tile: 'bg-emerald-700' },
  shipping: { icon: Truck, tile: 'bg-purple-600' },
  audit: { icon: History, tile: 'bg-slate-600' },
}

export function moduleStyle(moduleId: string): { icon: LucideIcon; tile: string } | null {
  if (OWN[moduleId]) return OWN[moduleId]
  const tile = TILES.get(moduleId)
  const icon = tile ? dashboardNavIcons[tile.label] : undefined
  if (tile && icon) return { icon, tile: tile.tile }
  return dashboardModule(moduleId) ? { icon: ClipboardList, tile: 'bg-gray-500' } : null
}
